import { Field } from "../types";
import { Input, Select, Switch, TagList } from "../components/form";
import { transformDate } from "../date";

export const RenderSingleField = (field: Field) => {
  const { type, value, name, cases, editable, action, modal } = field;

  const stringValue = value ? value.toString() : "";
  const disabled = !editable && !action && !modal;

  switch (type) {
    case "integer":
    case "number":
      return (
        <Input
          type="number"
          value={stringValue}
          name={name}
          fieldType={type}
          disabled={disabled}
        />
      );
    case "date":
      return (
        <Input
          type="date"
          value={transformDate(stringValue)}
          name={name}
          fieldType={type}
          disabled={disabled}
        />
      );
    case "string":
      return (
        <Input
          type="text"
          value={stringValue}
          name={name}
          fieldType={type}
          disabled={disabled}
        />
      );
    case "select":
      return (
        <Select
          cases={cases}
          value={stringValue}
          name={name}
          disabled={disabled}
        />
      );
    case "boolean":
      return (
        <Switch checked={value as boolean} name={name} disable={disabled} />
      );
    case "tag_list":
      return (
        <TagList value={value as string[]} name={name} disabled={disabled} />
      );
    default:
      return "";
  }
};
